import React from 'react';
import styled, { css } from 'styled-components';
import { useGenre } from '../../api';

import { GenreLink } from './Link';

interface Props {
  genreId: number;
  className?: string;
}

const GenreLabel = ({ genreId, className }: Props) => {
  const genre = useGenre(genreId);

  if (!genre) {
    return null;
  }

  return (
    <Container
      text_color={genre.text_color}
      background_color={genre.background_color}
      className={className}
    >
      {genre.name}
    </Container>
  );
};

const GenreLabelLink = styled(({ genreId, className }: Props) => {
  const genre = useGenre(genreId);

  if (!genre) {
    return null;
  }

  return (
    <Link
      text_color={genre.text_color}
      background_color={genre.background_color}
      className={className}
      genreId={genreId}
    >
      {genre.name}
    </Link>
  );
})``;

export { GenreLabel, GenreLabelLink };
export default GenreLabelLink;

const sharedStyle = css<{ text_color?: string; background_color?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: lowercase;
  padding: 2px 8px;
  color: ${(p) => p.text_color ?? ''};
  background-color: ${(p) => p.background_color ?? ''};
  font-size: 12px;
  border-radius: 5px;
`;

const Link = styled(GenreLink)`
  ${sharedStyle}
`;

const Container = styled.div`
  ${sharedStyle}
`;
